import { type ReactNode } from 'react'
import { Modal } from './Modal'
import { IconoAlerta, IconoCheck, IconoCerrar } from '@/shared/ui/Iconos/Iconos'
import estilos from './ModalConfirmacion.module.css'

export interface PropsModalConfirmacion {
  abierto: boolean
  titulo: string
  mensaje: string
  submensaje?: string
  textoConfirmar?: string
  textoCancelar?: string
  tipo?: 'peligro' | 'primario' | 'advertencia'
  icono?: 'peligro' | 'check' | 'alerta'
  alConfirmar: () => void
  alCancelar: () => void
  children?: ReactNode
}

export function ModalConfirmacion({
  abierto,
  titulo,
  mensaje,
  submensaje,
  textoConfirmar = 'Confirmar',
  textoCancelar = 'Cancelar',
  tipo = 'primario',
  icono = 'alerta',
  alConfirmar,
  alCancelar,
  children,
}: PropsModalConfirmacion) {
  if (!abierto) return null

  const pie = (
    <div className={estilos.pieBotones}>
      <button
        type="button"
        className={estilos.btnCancelar}
        onClick={alCancelar}
      >
        <IconoCerrar style={{ width: '14px', height: '14px' }} />
        <span>{textoCancelar}</span>
      </button>

      <button
        type="button"
        className={`${estilos.btnConfirmar} ${estilos['btn_' + tipo]}`}
        onClick={() => {
          alConfirmar()
          alCancelar()
        }}
      >
        {tipo === 'primario' && <IconoCheck style={{ width: '14px', height: '14px' }} />}
        {tipo === 'peligro' && <IconoAlerta style={{ width: '14px', height: '14px' }} />}
        {tipo === 'advertencia' && <IconoAlerta style={{ width: '14px', height: '14px' }} />}
        <span>{textoConfirmar}</span>
      </button>
    </div>
  )

  return (
    <Modal
      abierto={abierto}
      titulo={titulo}
      onCerrar={alCancelar}
      pie={pie}
    >
      <div className={estilos.cuerpoDialogo}>
        <div className={`${estilos.iconoContenedor} ${estilos['icono_' + tipo]}`}>
          {icono === 'check' ? (
            <IconoCheck style={{ width: '24px', height: '24px' }} />
          ) : (
            <IconoAlerta style={{ width: '24px', height: '24px' }} />
          )}
        </div>

        <div className={estilos.textosContenedor}>
          <p className={estilos.mensajePrincipal}>{mensaje}</p>
          {submensaje && <p className={estilos.submensajeSecundario}>{submensaje}</p>}
          {children}
        </div>
      </div>
    </Modal>
  )
}

